import { observer } from 'mobx-react'
import { type FC } from 'react'
import styles from './AppContainer.module.css'
import AlertModal from '../AlertModal'

const AppContainer: FC = observer(({ children }) => {
  return (
    <div className={styles.container}>
      <div className="top-4 fixed right-4">
        <AlertModal variant="standard" />
      </div>
      {children}
    </div>
  )
})

export default AppContainer
